// 设备购买 变更为 海外咨询
import React, { Component } from "react";
import FetchData from '@ezviz/FetchData';
import Cookies from "js-cookie";
import { Form, Select, message } from "antd";
import { Modal, Rate, Input, Button, Icon } from '@ezviz/ezd';

import "./index.less";

const FeedbackTip = {
  5: "非常满意",
  4: "比较满意",
  3: "一般",
  2: "比较不满意",
  1: "非常不满意"
}

const FormItem = Form.Item;

message.config({
  top: "40%"
});

class WrappedProbationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      hoverValue: 0,
      reason: [],
      step: 0,
      modal: false,
      loading: false,
      feedbackTitle: props.feedbackTitle || "调查问卷标题",
      badReason: props.badReason || [],
      goodReason: props.goodReason || [],
    };
    this.timer = null;
  };

  showModal = key => (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      modal: true,
    });
    if(this.timer) clearTimeout(this.timer);
    window.monitor && window.monitor.report({textKey: `website_fixbar_${this.props.ptype}`, text: this.props.title});
  };

  onClose = key => () => {
    if(this.timer) clearTimeout(this.timer);
    this.setState({
      modal: false,
      value: 0,
      hoverValue: 0,
      reason: [],
      step: 0,
      loading: false,
    })
  };

  addFeedback = (values) => {
    this.setState({
      loading: true,
    })

    let params = {
      source: decodeURIComponent(window.location.href),
      identifier: `ezviz_user${new Date().getTime()}${parseInt(Math.random() * 10000)}`,
      account: Cookies.get('ASG_DisplayName') || '',
    };

    Object.assign(params, { 
      sorce: values.sorce,
      sorceTag: values.sorceTag,
      suggestion: values.suggestion,
     });

    const succes = data => {
      this.setState({
        loading: false,
      })
      if (data.meta && data.meta.code === 200) {
        this.setState({
          step: 1,
        });
        this.timer = setTimeout(() => {
          this.setState({
            modal: false,
            value: 0,
            hoverValue: 0,
            reason: [],
            step: 0,
            loading: false,
          })
        }, 3000);
        message.destroy();
      } else {
        message.error("提交失败，请重试");
      }
    };
    const error = error => {
      this.setState({
        loading: false,
      })
      message.destroy();
    };
    const fetchData = new FetchData('/web/console/feedback/info', {
      method: 'POST',
      body: params
    });
    fetchData.then((data) => {
        succes(data);
      })
      .catch((err) => {
        console.log(err);
        error(err)
      })
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let that = this;
        that.addFeedback(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { step, value, hoverValue, reason, feedbackTitle, badReason, goodReason, loading } = this.state;
    const { width = 350, height = 648, } = this.props;
    const isShowSourceTag = hoverValue > 0 ? hoverValue : (value > 0 ? value : 0);
    
    return (
      <div>
        {this.props.text ?
          <div className={this.props.className} onClick={this.showModal()}>{this.props.text}</div>
          :
          <div onClick={this.showModal()}>
            {this.props.children}
          </div>
        }
        <Modal
          visible={this.state.modal}
          destroyOnClose
          transparent
          width={width}
          closable
          maskClosable={false}
          onCancel={this.onClose()}
          mask={false}
          title={false}
          footer={false}
          onClose={this.onClose()}
          centered={false}
          className="feedback-modal"
          getContainer={this.props.parentNode}
          style={{ right: 106, bottom: 100, position: 'absolute', top: 'auto' }}
        >
          <div className="feedback-wrap">
            {step === 0 &&
              <div className={`common-contact-us-form white mobile`}>
                <Form className="work-form">
                  <FormItem label={feedbackTitle} colon={false}>
                    {getFieldDecorator("sorce", {})(
                      <span className="rate-wrap">
                        <Rate allowClear={false}
                          onHoverChange={(value)=>{
                            this.setState({
                              hoverValue: value
                            })
                            console.log(`value`, value)
                          }}
                          onChange={(value)=>{
                            this.setState({
                              value,
                              reason: value > 3 ? [] : reason
                            })
                            this.props.form.setFieldsValue({
                              sorce: value,
                            });
                            if(value<=3) {
                              this.props.form.setFieldsValue({
                                sorceTag: ''
                              });
                            }
                          }} 
                        />
                        {isShowSourceTag > 0 &&
                          <span className="ezd-rate-text">{FeedbackTip[isShowSourceTag]}</span>
                        }
                      </span>
                    )}
                  </FormItem>
                  {((goodReason.length >0 && value>3) || (badReason.length >0 && value > 0 && value <=3 )) &&
                    <FormItem label="您给出此评分的原因是？" colon={false}>
                      {getFieldDecorator("sorceTag", {
                        rules: []
                      })(
                          <div className="reason-list-warp">
                            {value <= 3 ?
                              <div className="reason-list">
                                {badReason.map(v=>{
                                  return <div onClick={() => {
                                    // 若v在reason中，则删除，否则添加
                                    let index = reason.indexOf(v);
                                    if(index > -1) {
                                      reason.splice(index, 1);
                                    } else {
                                      reason.push(v);
                                    }
                                    this.setState({
                                      reason
                                    })
                                    this.props.form.setFieldsValue({
                                      sorceTag: reason.join(','),
                                    });
                                  }} className={`reason-item ${reason.indexOf(v) > -1 ? 'select': ''}`}>{v}</div>
                                })}
                              </div>
                            :  
                              <div className="reason-list">
                                {goodReason.map(v=>{
                                  return <div onClick={() => {
                                    // 若v在reason中，则删除，否则添加
                                    let index = reason.indexOf(v);
                                    if(index > -1) {
                                      reason.splice(index, 1);
                                    } else {
                                      reason.push(v);
                                    }
                                    this.setState({
                                      reason
                                    })
                                    this.props.form.setFieldsValue({
                                      sorceTag: reason.join(','),
                                    });
                                  }} className={`reason-item ${reason.indexOf(v) > -1 ? 'select': ''}`}>{v}</div>
                                })}
                              </div>
                            }
                          </div>
                      )}
                    </FormItem>
                  }
                  {value > 0 &&
                    <FormItem label="期待您提供更多改进建议">
                      {getFieldDecorator("suggestion", {
                        rules: []
                      })(
                        <Input.TextArea placeholder="请输入" className="feedback-other"
                          autoCapitalize={false}
                          autoComplete={false}
                          maxLength={1000}
                        />
                      )}
                    </FormItem>
                  }
                </Form>
                {value > 0 &&
                  <Button type="primary" loading={loading} className="submit-btn" onClick={this.handleSubmit} >提交</Button>
                }
                
              </div>
            }
            {step === 1 &&
              <div className={`submit-success ${this.props.theme}`}>
                <div className="success-title"><Icon type="success-filled" />感谢您的反馈！</div>
                <div className="success-sub-title">我们会对每一条反馈做好评估与改进，期待您提供更多反馈或建议</div>
              </div>
            }
          </div>
        </Modal>
      </div>

    );
  }
}

const Feedback = Form.create()(WrappedProbationForm);

export default Feedback;
